// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Int from "../../../../node_modules/rescript/lib/es6/belt_Int.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Unicons$Showside from "../icons/Unicons.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as PDPOptionButton$Showside from "./PDPOptionButton.bs.js";
function QuantityPicker(Props) {
  var quantityOptionSize = Props.quantityOptionSize;
  var optionSize = Props.optionSize;
  var minOpt = Props.min;
  var max = Props.max;
  var quantity = Props.quantity;
  var setQuantity = Props.setQuantity;
  var className = Props.className;
  var min = minOpt !== undefined ? minOpt : 1;
  var quantityOptionSize$1 = Belt_Option.getWithDefault(quantityOptionSize, optionSize);
  var iconSize;
  switch (quantityOptionSize$1) {
    case /* Xs */0:
    case /* Sm */1:
      iconSize = /* Px */{
        _0: 14
      };
      break;
    case /* Md */2:
      iconSize = /* Px */{
        _0: 16
      };
      break;
    case /* Lg */3:
      iconSize = /* Px */{
        _0: 20
      };
      break;
    case /* Xl */4:
    case /* Xxl */5:
      iconSize = /* Px */{
        _0: 24
      };
      break;
  }
  var disabledPlus = max !== undefined && quantity !== undefined ? quantity >= max : false;
  var disabledMinus = quantity !== undefined && min !== 1 ? quantity <= min : false;
  var tmp;
  var exit = 0;
  if (quantity !== undefined && (quantity - 1 | 0) === min && min === 0) {
    tmp = React.createElement(Unicons$Showside.UilTrash.make, {
      size: iconSize
    });
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = React.createElement(Unicons$Showside.UilMinus.make, {
      size: iconSize
    });
  }
  var tmp$1;
  switch (optionSize) {
    case /* Xs */0:
    case /* Sm */1:
      tmp$1 = "text-base";
      break;
    case /* Md */2:
      tmp$1 = "text-lg";
      break;
    case /* Lg */3:
      tmp$1 = "text-xl";
      break;
    case /* Xl */4:
    case /* Xxl */5:
      tmp$1 = "text-2xl";
      break;
  }
  var q = Belt_Option.map(quantity, function (prim) {
    return String(prim);
  });
  var tmp$2 = {
    "aria-label": "Quantity",
    className: CSS$Showside.prefix(Cn.make(["relative", "text-primary text-center inline-block font-medium border-0 bg-transparent", "h-full w-full", "shadow-none", "no-controls", tmp$1])),
    style: {
      width: "46px"
    },
    min: String(min),
    type: "number",
    value: q !== undefined ? q : "",
    onBlur: function (param) {
      Curry._1(setQuantity, function (q) {
        var withLowerLimit = Belt_Option.mapWithDefault(q, min, function (param) {
          return Math.max(min, param);
        });
        if (max !== undefined) {
          return Math.min(max, withLowerLimit);
        } else {
          return withLowerLimit;
        }
      });
    },
    onChange: function (e) {
      var target = e.target;
      Curry._1(setQuantity, function (param) {
        return Belt_Int.fromString(target.value);
      });
    }
  };
  var tmp$3 = Belt_Option.map(max, function (prim) {
    return String(prim);
  });
  if (tmp$3 !== undefined) {
    tmp$2.max = Caml_option.valFromOption(tmp$3);
  }
  return React.createElement(DataAttribute$Showside.make, {
    dataTestId: "pdp-quantity-picker",
    children: React.createElement("div", {
      className: Cn.make([CSS$Showside.prefix("inline-flex flex-wrap flex-shrink-0 relative"), CSS$Showside.prefix(quantityOptionSize$1 >= 3 ? "gap-3" : ""), Belt_Option.getWithDefault(className, "")])
    }, React.createElement("div", {
      className: CSS$Showside.prefix("border border-solid border-gray-200 absolute inset-0")
    }), React.createElement(PDPOptionButton$Showside.make, {
      disabled: disabledMinus,
      selected: false,
      icon: tmp,
      size: quantityOptionSize$1,
      style: /* NoBorder */1,
      dataTestId: "pdp-quantity-minus",
      onClick: function (param) {
        Curry._1(setQuantity, function (q) {
          if (q !== undefined) {
            return Math.max(min, q - 1 | 0);
          } else {
            return min;
          }
        });
      }
    }), React.createElement("div", {
      className: CSS$Showside.prefix("relative inline-block group-2 flex-grow")
    }, React.createElement(DataAttribute$Showside.make, {
      dataTestId: "pdp-quantity-input",
      children: React.createElement("input", tmp$2)
    })), React.createElement(PDPOptionButton$Showside.make, {
      disabled: disabledPlus,
      selected: false,
      icon: React.createElement(Unicons$Showside.UilPlus.make, {
        size: iconSize
      }),
      size: quantityOptionSize$1,
      style: /* NoBorder */1,
      dataTestId: "pdp-quantity-plus",
      onClick: function (param) {
        Curry._1(setQuantity, function (q) {
          if (max !== undefined) {
            if (q !== undefined) {
              return Math.min(max, q + 1 | 0);
            } else {
              return 1;
            }
          } else if (q !== undefined) {
            return q + 1 | 0;
          } else {
            return 1;
          }
        });
      }
    }))
  });
}
QuantityPicker.displayName = "QuantityPicker";
var make = QuantityPicker;
export { make };
/* react Not a pure module */